import { createContext } from "react";

const initialValue = {
  districts: [],
  user: {
    name: "",
    role: "",
    email: "",
    auth_token: "",
  },
};

export const province_Context = createContext(initialValue);

province_Context.displayName = "Province Context";
